export default __webpack_public_path__ + "static/media/CardMark.c3594d59.png";